import axios from "axios";
//创建axios实例
export const request = axios.create({
    //http://localhost:8080/
    baseURL: 'https://api.crashm.com/bbnsb567-t85i-1l7b-99yz-z123wxy88ffz/',
    timeout: 10000
});